import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    deliveryDays: [],
    isLoading: false,
    packProperties: [],
    filters: [],
    promoFilters: [],
    unauthorizedFilters: [],
    appliedUnauthorizedFilters: [],
    unauthorizedFilterIds: [],
    maxActiveFiltersCount: null,
    setProposedFiltersVersion: false,
    isUpdateFiltersModalVisible: false,
  },
  actions,
  getters,
  mutations,
}
